import { CSSProperties } from 'react';

export const scopeRulesWrapperStyle: CSSProperties = {
  marginTop: 16,
};

export const scopeRulesBoxStyle: CSSProperties = {
  backgroundColor: '#ffffff',
  border: '1px solid #e2e8f0',
  borderRadius: 12,
  padding: 20,
};

export const scopeRulesHeaderStyle: CSSProperties = {
  marginBottom: 16,
};

export const scopeRulesTitleStyle: CSSProperties = {
  fontSize: 15,
  fontWeight: 600,
  color: '#191c1f',
};

export const scopeRulesHintStyle: CSSProperties = {
  display: 'block',
  marginTop: 4,
  fontSize: 13,
  color: '#94a3b8',
};

export const scopeRulesEmptyStyle: CSSProperties = {
  marginTop: 10,
  marginBottom: 0,
  color: '#94a3b8',
  fontSize: 13,
};

export const scopeRulesListStyle: CSSProperties = {
  marginTop: 12,
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
};

export const scopeRuleRowStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  gap: 12,
  padding: 16,
  border: '1px solid #e2e8f0',
  borderRadius: 10,
  backgroundColor: '#ffffff',
  transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
};

export const scopeRuleRowHoverStyle: CSSProperties = {
  borderColor: '#cbd5e1',
  boxShadow: '0 1px 3px rgba(0,0,0,0.04)',
};

export const scopeRuleFieldsRowStyle: CSSProperties = {
  display: 'flex',
  gap: 12,
  flexWrap: 'wrap',
  alignItems: 'flex-start',
};

export const scopeRuleDimensionColStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  minWidth: 180,
  flexShrink: 0,
};

export const scopeRuleEffectColStyle: CSSProperties = {
  minWidth: 140,
  flexShrink: 0,
};

export const scopeRuleValuesColStyle: CSSProperties = {
  minWidth: 260,
  flex: 1,
};

export const scopeRuleModeColStyle: CSSProperties = {
  minWidth: 130,
  flexShrink: 0,
};

export const scopeRuleActionsColStyle: CSSProperties = {
  flexShrink: 0,
  alignSelf: 'center',
};

export const scopeRuleHelpStyle: CSSProperties = {
  marginTop: 4,
  display: 'block',
  color: '#dc2626',
  fontSize: 13,
};

export const deprecatedTagStyle: CSSProperties = {
  backgroundColor: '#f1f5f9',
  color: '#64748b',
  border: '1px solid #e2e8f0',
};
